"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTypes = {
    full: 1,
    serviceDriveOnly: 2,
    fca_Express: 3,
    fca_Full: 4,
    euroLite: 5
};
